import { createSlice } from "@reduxjs/toolkit";
import { getBrandCampaignIds, getTotalClick, getClientCampaignIds, getCreativeClick, getCreativeImpression, getTotalImpression, getMarketCampaignIds, createChildTable, createImpressionByDeviceTable, createClickByDeviceTable, createLocationTable, createStatisticChart, createCreativeTable, getStatisticChart, getLocationTable, getClickTable, getImpressionTable, createAnalytics, createHeatmap, getCreativePreview, getFontList, getDynamicText } from "./thunk";
import { cleanString } from "../helper";
import { getTodayAndPastWeek } from "./helper";

export const initialState = {
  selectedClientId: null,
  selectedBrandId: null,
  selectedMarketId: null,
  selectedCampaignId: null,
  analyticsCampaigns: null,
  analyticsPreloader: false,
  startDate: getTodayAndPastWeek()[0].toISOString().split('T')[0],
  endDate: getTodayAndPastWeek()[1].toISOString().split('T')[0],
  infoContLoader: false,
  impression: null,
  click: null,
  prevImpression: null,
  prevClick: null,
  childTableLoader: false,
  childTableData: [],
  impressionByDeviceLoader: false,
  impressionByDeviceData: null,
  impressionModal: false,
  clickByDeviceLoader: false,
  clickByDeviceData: null,
  clickModal: false,
  locationLoader: false,
  locationData: null,
  statisticsChartLoader: false,
  statisticsChartData: null,
  creativesLoader: false,
  creativesData: null,
  versions: null,
  creatives: null,
  fontList: [],
  connectedFeed: null,
  creativeModal: false,
  creativePreview: null,
  heatmapLoader: false,
  heatmapTotalPage: 0,
  heatmapPage: 0,
  heatmapFirstData: null,
  heatmapData: null,
  feedPreview: null,
  dynamicText: null,
  activeDynamicText: null,
}

const analyticsSlice = createSlice({
  initialState,
  name: 'Analytics',
  reducers: {
    setSelectedClientId(state, action) {
      state.selectedClientId = action.payload;
    },
    setSelectedBrandId(state, action) {
      state.selectedBrandId = action.payload;
    },
    setSelectedMarketId(state, action) {
      state.selectedMarketId = action.payload;
    },
    setSelectedCampaignId(state, action) {
      state.selectedCampaignId = action.payload;
    },
    setAnalyticsCampaigns(state, action) {
      state.analyticsCampaigns = action.payload;
    },
    setAnalyticsPreloader(state, action) {
      state.analyticsPreloader = action.payload;
    },
    setStartDate(state, action) {
      state.startDate = action.payload;
    },
    setEndDate(state, action) {
      state.endDate = action.payload;
    },
    setInfoContLoader(state, action) {
      state.infoContLoader = action.payload;
    },
    setImpression(state, action) {
      state.impression = action.payload;
    },
    setClick(state, action) {
      state.click = action.payload;
    },
    setChildTableLoader(state, action) {
      state.childTableLoader = action.payload;
    },
    setChildTableData(state, action) {
      state.childTableData = action.payload;
    },
    setImpressionByDeviceLoader(state, action) {
      state.impressionByDeviceLoader = action.payload;
    },
    setImpressionByDeviceData(state, action) {
      state.impressionByDeviceData = action.payload;
    },
    setClickByDeviceLoader(state, action) {
      state.clickByDeviceLoader = action.payload;
    },
    setClickByDeviceData(state, action) {
      state.clickByDeviceData = action.payload;
    },
    setLocationLoader(state, action) {
      state.locationLoader = action.payload;
    },
    setLocationData(state, action) {
      state.locationData = action.payload;
    },
    setStatisticsChartLoader(state, action) {
      state.statisticsChartLoader = action.payload;
    },
    setStatisticsChartData(state, action) {
      state.statisticsChartData = action.payload;
    },
    getCreatives(state, action) {
      state.getCreatives = () => { action.payload() };
    },
    setCreativesData(state, action) {
      state.creativesData = action.payload;
    },
    setCreativesLoader(state, action) {
      state.creativesLoader = !state.creativesLoader;
    },
    setVersions(state, action) {
      state.versions = action.payload;
    },
    setCreatives(state, action) {
      state.creatives = action.payload;
    },
    setConnectedFeed(state, action) {
      state.connectedFeed = action.payload;
    },
    updateCreativeFigmaAfterDynamicText(state, action) {
      const { activeDynamicText, creativeIds } = action.payload;
      const texts = activeDynamicText.texts;
      const updatedCreatives = [];
      let i = 0;
      do {
        if (creativeIds.some(id => id === state.creatives[i]._id)) {
          let foundCreative = { ...state.creatives[i] };
          let k = 0;
          do {
            const elIds = Object.keys(foundCreative.figmaObject.node);
            if (texts[k]?.type === "text") {
              let l = 0;
              do {
                if (foundCreative.figmaObject.node[elIds[l]].hasOwnProperty("name")) {
                  if (cleanString(foundCreative.figmaObject.node[elIds[l]].name) === cleanString(texts[k].name)) {
                    foundCreative.figmaObject.node[elIds[l]].characters = texts[k].value;
                    try {
                      if (texts[k]?.isFeed) {
                        const foundFeed = state.connectedFeed.find(item => item.path === foundCreative.figmaObject.node[elIds[l]].characters);
                        if (foundFeed !== undefined && foundFeed !== null) {
                          foundCreative.figmaObject.node[elIds[l]].characters = `<p style='${texts[k].style}'>${foundFeed.values[0]}</p>`;
                        }
                      }
                    } catch (error) {
                      foundCreative.figmaObject.node[elIds[l]].characters = texts[k].value;
                    }
                    break;
                  }
                }
                l++;
              } while (l < elIds.length);
            } else if (texts[k]?.type === "image") {
              let l = 0;
              do {
                if (foundCreative.figmaObject.node[elIds[l]] && foundCreative.figmaObject.node[elIds[l]].hasOwnProperty("name")) {
                  if (cleanString(foundCreative.figmaObject.node[elIds[l]].name) === cleanString(texts[k].name)) {
                    if (foundCreative.figmaObject.node[elIds[l]].hasOwnProperty("bgimages")) {
                      foundCreative.figmaObject.node[elIds[l]].bgimages["1x"].data = texts[k].value;
                      foundCreative.figmaObject.node[elIds[l]].bgimages["2x"].data = texts[k].value;
                    }
                    break;
                  }
                }
                l++;
              } while (l < elIds.length);
            }
            k++;
          } while (k < texts.length);
          updatedCreatives.push(foundCreative);
        } else {
          updatedCreatives.push(state.creatives[i]);
        }
        i++;
      } while (i < state.creatives.length);
      state.creatives = updatedCreatives;
      state.filteredCreatives = updatedCreatives;
    },
    toggleCreativeModal(state) {
      state.creativeModal = !state.creativeModal;
    },
    setHeatmapTotalPage(state, action) {
      state.heatmapTotalPage = action.payload;
    },
    setHeatmapPage(state, action) {
      state.heatmapPage = action.payload;
    },
    setHeatmapFirstData(state, action) {
      state.heatmapFirstData = action.payload;
    },
    setHeatmapData(state, action) {
      // if (Array.isArray(state.heatmapData)) {
      //   state.heatmapData.push(action.payload);
      // } else {
      state.heatmapData = action.payload;
      // }
    },
    setFeedPreview(state, action) {
      state.feedPreview = action.payload;
    },
    setDynamicText(state, action) {
      state.dynamicText = action.payload;
    },
    setActiveDynamicText(state, action) {
      state.activeDynamicText = action.payload;
    },
    resetAnalyticsState(state, action) {
      state.selectedClientId = null;
      state.selectedBrandId = null;
      state.selectedMarketId = null;
      state.selectedCampaignId = null;
      state.analyticsCampaigns = null;
      state.analyticsPreloader = false;
      state.startDate = getTodayAndPastWeek()[0].toISOString().split('T')[0];
      state.endDate = getTodayAndPastWeek()[1].toISOString().split('T')[0];
      state.infoContLoader = false;
      state.impression = null;
      state.click = null;
      state.prevImpression = null;
      state.prevClick = null;
      state.childTableLoader = false;
      state.childTableData = [];
      state.impressionByDeviceLoader = false;
      state.impressionByDeviceData = null;
      state.impressionModal = false;
      state.clickByDeviceLoader = false;
      state.clickByDeviceData = null;
      state.clickModal = false;
      state.locationLoader = false;
      state.locationData = null;
      state.statisticsChartLoader = false;
      state.statisticsChartData = null;
      state.creativesLoader = false;
      state.creativesData = null;
      state.versions = null;
      state.creatives = null;
      state.fontList = [];
      state.connectedFeed = null;
      state.creativeModal = false;
      state.creativePreview = null;
      state.heatmapLoader = false;
      state.heatmapTotalPage = 0;
      state.heatmapPage = 0;
      state.heatmapFirstData = null;
      state.heatmapData = null;
      state.feedPreview = null;
      state.dynamicText = null;
      state.activeDynamicText = null;
    }
  },
  extraReducers: builder => {
    builder.addCase(getMarketCampaignIds.fulfilled, (state, action) => {
      state.analyticsCampaigns = action.payload;
    });
    builder.addCase(getBrandCampaignIds.fulfilled, (state, action) => {
      state.analyticsCampaigns = action.payload;
    });
    builder.addCase(getClientCampaignIds.fulfilled, (state, action) => {
      state.analyticsCampaigns = action.payload;
    });
    builder.addCase(createAnalytics.pending, (state, action) => {
      state.analyticsPreloader = true;
    });
    builder.addCase(createAnalytics.fulfilled, (state, action) => {
      state.analyticsPreloader = false;
    })
    builder.addCase(getImpressionTable.pending, (state, action) => {
      state.impressionByDeviceLoader = true;
    });
    builder.addCase(getImpressionTable.fulfilled, (state, action) => {
      state.impressionByDeviceData = action.payload;
      state.impressionByDeviceLoader = false;
    });
    builder.addCase(getClickTable.pending, (state, action) => {
      state.clickByDeviceLoader = true;
    });
    builder.addCase(getClickTable.fulfilled, (state, action) => {
      state.clickByDeviceData = action.payload;
      state.clickByDeviceLoader = false;
    });
    builder.addCase(getLocationTable.pending, (state, action) => {
      state.locationLoader = true;
    });
    builder.addCase(getLocationTable.fulfilled, (state, action) => {
      state.locationData = action.payload;
      state.locationLoader = false;
    });
    builder.addCase(getStatisticChart.pending, (state, action) => {
      state.statisticsChartLoader = true;
    });
    builder.addCase(getStatisticChart.fulfilled, (state, action) => {
      state.statisticsChartData = action.payload;
      state.statisticsChartLoader = false;
    });
    builder.addCase(createCreativeTable.pending, (state, action) => {
      state.creativesLoader = true;
    });
    builder.addCase(createCreativeTable.fulfilled, (state, action) => {
      state.creativesData = action.payload;
      state.creativesLoader = false;
    });
    builder.addCase(getFontList.fulfilled, (state, action) => {
      state.fontList = action.payload;
    });
    builder.addCase(getCreativePreview.pending, (state, action) => {
      state.creativePreview = null;
      state.heatmapData = null;
      state.heatmapLoader = true;
    });
    builder.addCase(getCreativePreview.fulfilled, (state, action) => {
      state.creativePreview = action.payload;
      state.heatmapLoader = false;
    });
    builder.addCase(createHeatmap.pending, (state, action) => {
      // state.heatmapLoader = true;
    })
    builder.addCase(createHeatmap.fulfilled, (state, action) => {
      // state.heatmapData = action.payload;
      // state.heatmapLoader = false;
    });
    builder.addCase(getDynamicText.fulfilled, (state, action) => {
      state.dynamicText = action.payload;
      state.activeDynamicText = action.payload[0];
    });
  }
});

export const {
  setSelectedClientId,
  setSelectedBrandId,
  setSelectedMarketId,
  setSelectedCampaignId,
  setAnalyticsCampaigns,
  setAnalyticsPreloader,
  setStartDate,
  setEndDate,
  setInfoContLoader,
  setImpression,
  setClick,
  setChildTableLoader,
  setChildTableData,
  setImpressionByDeviceLoader,
  setImpressionByDeviceData,
  setClickByDeviceLoader,
  setClickByDeviceData,
  setLocationLoader,
  setLocationData,
  setStatisticsChartLoader,
  setStatisticsChartData,
  getCreatives,
  setCreativesData,
  setCreativesLoader,
  setVersions,
  setCreatives,
  setConnectedFeed,
  updateCreativeFigmaAfterDynamicText,
  toggleCreativeModal,
  setHeatmapTotalPage,
  setHeatmapPage,
  setHeatmapFirstData,
  setHeatmapData,
  setFeedPreview,
  setDynamicText,
  setActiveDynamicText,
  resetAnalyticsState
} = analyticsSlice.actions;

export default analyticsSlice.reducer;